import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { useTheme } from '@mui/material/styles';

import { ColourIndicator } from '../ColorIndicator/ColourIndicator';

interface Props {
  label: string;
  color: number[] | string;
  hidden: boolean;
  handleClick: () => void;
}

export const ColorLegendItem = ({ label, color: colour, hidden, handleClick }: Props) => {
  const dataTestId = hidden ? 'color-legend-icon-hollow' : 'color-legend-icon';
  const theme = useTheme();

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',

        ':hover': {
          backgroundColor: '#F9F9F9',
        },

        backgroundColor: hidden ? '#FFFFFF' : '#6347FF0D',
        border: 1,
        borderColor: hidden ? '#0D0C1D1A' : '#6347FF',
        borderRadius: 2,
        cursor: 'pointer',
      }}
    >
      <Checkbox size="small" checked={!hidden} />
      <ColourIndicator
        colour={colour}
        outlineColour={theme.palette.neutral[10]}
        dataTestId={dataTestId}
        label={label}
      />
    </Box>
  );
};
